import { createFileRoute } from '@tanstack/react-router'

import { InvoiceImportPage } from '@/pages/invoices/import/InvoiceImportPage'

export const Route = createFileRoute('/_authenticated/_dashboard/invoices/import/')({
  component: InvoiceImportPage,
})
